import React, { Component } from 'react'

import '../../../styles/css/components/edit/bk-flow-edit-stay-accessible.css'

class BkFlowEditAccessibleField extends Component {

	constructor(props) {
		super(props)
		this.state = {
		}
	}

	render() {
		const {
			currentAccessibility,
			handleToggleAccessible,
			hotelLabels
		} = this.props

		return (
			<div className="bk-flow-edit-stay__accessible-rooms row">
				<input
					type="checkbox"
					name="accessibleRooms"
					className="bk-flow-edit-stay__accessible-rooms-checkbox"
					placeholder="Accessible Rooms Only"
					value={ currentAccessibility }
					onClick={ () => handleToggleAccessible(currentAccessibility) }
					aria-labelledby="accessibleCodeLabel"
				 />
				<label htmlFor="accessibleRooms" id="accessibleCodeLabel">
					{ hotelLabels.accessibleRoomsOnly ? hotelLabels.accessibleRoomsOnly : 'Accessible rooms only' }
				</label>
			</div>
		)
	}
}


export default BkFlowEditAccessibleField


// WEBPACK FOOTER //
// ./src/components/edit/accessible/BkFlowEditAccessibleField.js